import { InputText } from '@dixa/lib-shared-habla';
import { Satisfaction } from 'lib-shared-legacy-types';
import * as React from 'react';

import { SafeInnerHtmlSetter } from 'components/shared/util/SafeInnerHtmlSetter';

import { RatingPreview } from './RatingPreview/RatingPreview';
import styles from './index.module.scss';

interface Props {
  ratingStyle: Satisfaction.RatingStyle;
  subjectText: string;
  emailBodyText: string;
  ratingQuestion: string;
}

export const EmailPreview: React.FunctionComponent<Props> = (props) => (
  <section className={styles.root}>
    <div className={styles.emailRoot}>
      <span className={styles.subject}>Subject:</span>
      <InputText
        className={styles.subjectInputField}
        name="subject"
        value={props.subjectText}
        readOnly
      />

      <section className={styles.emailBodyWrapper}>
        <SafeInnerHtmlSetter
          element="div"
          content={props.emailBodyText}
          className={styles.emailText}
        />

        <RatingPreview
          className={styles.csatRatingPreview}
          ratingStyle={props.ratingStyle}
          question={props.ratingQuestion}
        />
      </section>
    </div>
  </section>
);
